function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M15.833 9.584v.833c0 .23-.186.417-.417.417h-4.583v4.583c0 .23-.186.417-.417.417h-.833a.417.417 0 01-.417-.417v-4.583H4.583a.417.417 0 01-.417-.417v-.833c0-.23.187-.417.417-.417h4.583V4.584c0-.23.187-.417.417-.417h.833c.23 0 .417.187.417.417v4.583h4.583c.23 0 .417.187.417.417z"
});

var SvgPlus = function SvgPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "#fff"
  }, props), _ref);
};

export default SvgPlus;